import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
/**
 * Flattens every mounted plugin's primaryAction candidates and orders them by
 * priority (higher wins). `Array.prototype.sort` is stable, so equal priorities
 * keep registration order — the order plugins were mounted and, within a plugin,
 * the order the arms were declared.
 */
export function collectPrimaryActionCandidates(plugins) {
    const candidates = plugins.flatMap((plugin) => plugin.primaryAction ?? EMPTY_ARRAY);
    if (candidates.length === 0) {
        return EMPTY_ARRAY;
    }
    return [...candidates].sort((a, b) => b.priority - a.priority);
}
//# sourceMappingURL=collectPrimaryActionCandidates.js.map